import request from '@/utils/request'

export function getPaymentSubTransactionApi() {
  return request({
    url: '/config-service/v1/hotel/price-code/sub-transaction',
    method: 'get'
  })
}

export function getTransactionListApi(query) {
  return request({
    url: '/config-service/v1/select-service/transactions',
    method: 'get',
    params: query
  })
}

export function getSubTransactionListApi(transId) {
  return request({
    url: `/config-service/v1/select-service/sub-transaction/${transId}`,
    method: 'get'
  })
}
